<button bbButton (bbKeyboardClick)="action()">Click Me!</button>
